"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.rawTextFromState = rawTextFromState;
exports.parseEditorState = parseEditorState;
exports.markOverflow = markOverflow;
exports.maybeHtmlFromState = exports.htmlFromState = exports.isEditorState = void 0;

var _flow = _interopRequireDefault(require("lodash/flow"));

var _isFunction = _interopRequireDefault(require("lodash/isFunction"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _draftJs = require("draft-js");

var _draftJsExportHtml = require("draft-js-export-html");

var _beNovativeKit = _interopRequireDefault(require("@bit/be-novative.kit.sanitize-for-json"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var isEditorState = function isEditorState(target) {
  return (0, _isObject.default)(target) && (0, _isFunction.default)(target.getCurrentContent);
};

exports.isEditorState = isEditorState;

function rawTextFromState(editorState) {
  if (!isEditorState(editorState)) {
    return '';
  }

  try {
    return editorState.getCurrentContent().getPlainText();
  } catch (error) {
    console.error('Could not convert EditorState to plain text', error);
    throw error;
  }
}

var htmlFromState = function htmlFromState(draftState) {
  if (isEditorState(draftState)) {
    var content = draftState.getCurrentContent();

    try {
      return (0, _flow.default)(_draftJsExportHtml.stateToHTML, _beNovativeKit.default)(content);
    } catch (e) {
      console.error('Could not convert EditorState to HTML', e);
      throw e;
    }
  }
};

exports.htmlFromState = htmlFromState;

var maybeHtmlFromState = function maybeHtmlFromState(target) {
  return typeof target === 'string' ? target : htmlFromState(target);
};

exports.maybeHtmlFromState = maybeHtmlFromState;

function parseEditorState(raw) {
  var editorState;

  if (!raw) {
    return _draftJs.EditorState.createEmpty();
  }

  var blocksFromHTML = (0, _draftJs.convertFromHTML)(raw);

  var state = _draftJs.ContentState.createFromBlockArray(blocksFromHTML.contentBlocks, blocksFromHTML.entityMap);

  editorState = _draftJs.EditorState.createWithContent(state);
  return editorState;
}

function getMaxLengthAnchor(currentLength, maxLength, contentBlock, contentState) {
  if (!contentBlock) {
    return null;
  }

  var length = currentLength + contentBlock.getLength();

  if (maxLength <= length) {
    return {
      anchorKey: contentBlock.getKey(),
      anchorOffset: contentBlock.getLength() - (length - maxLength)
    };
  }

  return getMaxLengthAnchor(length + 1, maxLength, contentState.getBlockAfter(contentBlock.getKey()), contentState);
}

function markOverflow(editorState, maxLength, inlineStyle) {
  var contentState = editorState.getCurrentContent();
  var anchor = getMaxLengthAnchor(0, maxLength, contentState.getFirstBlock(), contentState);

  if (anchor) {
    var currentSelection = editorState.getSelection();
    var focus = {
      focusKey: contentState.getLastBlock().getKey(),
      focusOffset: contentState.getLastBlock().getLength()
    };
    var markSelection = new _draftJs.SelectionState(_objectSpread({}, anchor, {}, focus));
    var clearSelection = new _draftJs.SelectionState(_objectSpread({
      anchorKey: contentState.getFirstBlock().getKey(),
      anchorOffset: 0
    }, focus));
    contentState = _draftJs.Modifier.removeInlineStyle(contentState, clearSelection, inlineStyle);
    contentState = _draftJs.Modifier.applyInlineStyle(contentState, markSelection, inlineStyle);
    editorState = _draftJs.EditorState.push(editorState, contentState, 'change-inline-style'); // restore original selection if has focus

    if (currentSelection.getHasFocus()) {
      editorState = _draftJs.EditorState.forceSelection(editorState, currentSelection);
    }
  }

  return editorState;
}

//# sourceMappingURL=index.js.map